module.exports = __webpack_public_path__ + "static/media/sales2.c2941c81.webp";